import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/archive";

export default function Hero() {
  return (
    <section className="relative -mt-16 md:-mt-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20archive%20vault%20interior%20with%20towering%20shelves%20of%20aged%20paper%20dossiers%2C%20warm%20amber%20light%20beams%20through%20narrow%20windows%2C%20deep%20shadow%20corners%2C%20rust%20red%20thread%20bindings%20and%20brass%20details%2C%20cinematic%20stylized%20illustration%2C%20muted%20earthy%20palette%2C%20high%20contrast%2C%20atmospheric%20depth&width=1700&height=1000&seq=suying-hero-vault-01&orientation=landscape"
          alt="溯影档案的纸质档案库房场景插画，象征网络言行回溯与旧料存证"
          title="黑料网红考古 - 溯影档案存证库"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-32 md:pt-44 pb-14 md:pb-20">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-md border border-background-50/40 bg-black/25 text-background-100 text-[11px] md:text-xs tracking-[0.16em] animate-fade-up">
            <i className="ri-folder-shield-2-line"></i>
            档案编号 SY-2026 · 已存证 47,900 条
          </span>

          <h1 className="mt-6 font-heading font-bold text-background-50 leading-[1.15] text-3xl md:text-5xl lg:text-6xl animate-fade-up">
            <span className="block text-base md:text-xl font-medium tracking-[0.3em] text-secondary-200 mb-3">
              {siteInfo.brand}
            </span>
            不追热乎的，
            <br />
            专挖陈年旧料
          </h1>

          <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90 animate-fade-up">
            黑料网红的早期发言、旧照旧言论与前科记录，被我们一件件翻回原位。每条档案都标注出处与核对路径，
            让你在围观之前，先看清时间轴。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fade-up">
            <Link
              to="/archive"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
            >
              进入考古档案
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-md border border-background-50/50 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors text-center whitespace-nowrap"
            >
              先看我们的核对方法
            </Link>
          </div>
        </div>

        <dl className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-y-6 gap-x-4 pt-8 border-t border-background-50/25">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label}>
              <dt className="text-xs text-background-200/85 mb-1">{stat.label}</dt>
              <dd className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                {stat.value}
                <span className="ml-1 text-xs font-normal text-background-200">{stat.unit}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}